import { Radio as MuiRadio, FormControlLabel } from '@mui/material';
import type {
  RadioProps as MuiRadioProps,
  FormControlLabelProps as MuiFormControlLabelProps,
} from '@mui/material';

export type RadioProps = MuiRadioProps & {
  value: MuiFormControlLabelProps['value'];
  label: MuiFormControlLabelProps['label'];
  formControlLabelProps?: Omit<MuiFormControlLabelProps, 'value' | 'label'>;
};
export const Radio = ({
  formControlLabelProps,
  onChange,
  onBlur,
  value,
  label,
  ...props
}: RadioProps) => {
  return (
    <FormControlLabel
      {...formControlLabelProps}
      control={
        <MuiRadio
          color="primary"
          {...props}
          onChange={(event, checked) => {
            onChange?.(event, checked);
          }}
          onBlur={e => {
            onBlur?.(e);
          }}
        />
      }
      value={value}
      label={label}
    />
  );
};
